function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

// A CSV export failure arrives as a Blob (responseType: 'blob'), so the JSON
// error body has to be read back out of it before apiErrorMessage can use it.
export async function parseBlobExportError(error: unknown): Promise<unknown> {
    if (!isRecord(error)) return error;
    const response = error.response;
    if (!isRecord(response) || !(response.data instanceof Blob)) return error;
    let parsed: unknown;
    try {
        parsed = JSON.parse(await response.data.text());
    } catch {
        // A non-JSON body (proxy error page) leaves the fallback message.
        return error;
    }
    // Copied, not mutated: the original keeps its blob body for inspection.
    return { ...error, response: { ...response, data: parsed } };
}
